import fetchRecentlyViewedMerchandise from 'actions/merchandise/fetchRecentlyViewedMerchandise'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useEffect } from 'react'

type ReturnType = [
  Array<string>,
  boolean,
  any,
]

function useRecentlyViewedMerchandise(): ReturnType {
  const dispatch = useAppDispatch()
  const recentlyViewedMerchandise = useAppSelector(state => state.merchandise.recentlyViewedMerchandise)

  useEffect(() => {
    dispatch(fetchRecentlyViewedMerchandise())
  }, [dispatch])

  return [
    recentlyViewedMerchandise?.merchandiseIds ?? EmptyArray,
    !!recentlyViewedMerchandise?.fetching,
    recentlyViewedMerchandise?.error,
  ]
}

export default useRecentlyViewedMerchandise
